(function() {
  var colorMap = {
    'ブラック':       '#1a1816',
    'グレージュ':     '#AB9A86',
    'オフホワイト':   '#F8F7F1',
    'ブルー':         '#9dccd7ff',
    'カーキブラウン': '#514524',
    'ダークネイビー': '#1F2F54',
    'ライトグレー':   '#E7E5E5'
  };

  function getSelectedVariant() {
    var active = document.querySelector('.product-options__value.active[data-title]');
    return active ? active.getAttribute('data-title') : 'ブラック';
  }

  function applyColor() {
    var name = getSelectedVariant();
    var bodyColor = colorMap[name] || '#1a1816';
    var body = document.getElementById('engraving-tag-body');
    if (body) body.setAttribute('fill', bodyColor);
  }

  function waitForInput() {
    var inp = document.getElementById('engraving-input');
    if (!inp) { setTimeout(waitForInput, 100); return; }

    applyColor();

    inp.addEventListener('input', function() {
      var val = this.value;
      var wrap = document.getElementById('engraving-preview');
      var svg  = document.getElementById('engraving-svg-text');
      var txt  = document.getElementById('engraving-text-preview');
      if (val.length > 0) {
        wrap.style.display = 'block';
        svg.textContent = val;
        txt.textContent = val;
        svg.setAttribute('font-size', val.length <= 2 ? 42 : val.length <= 3 ? 35 : val.length <= 4 ? 28 : 22);
      } else {
        wrap.style.display = 'none';
      }
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-options__value');
      if (btn) setTimeout(applyColor, 50);
    });
  }

  waitForInput();
})();